import React, { useState } from 'react';
import Logo from "../assets/img/listing.png";
import { MdDashboard } from "react-icons/md";
import { BiBookContent } from "react-icons/bi";
import { FaUser } from "react-icons/fa";
import { FaNetworkWired } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import { FaQuestionCircle } from "react-icons/fa";


import { Link, useLocation } from 'react-router-dom';
import ResizeHook from '../Components/Hooks/ResizeHook';
import { IoClose } from "react-icons/io5";

const Sidebar = ({ handleCloseHeader }) => {


  const [sidebarlinks] = useState([
    {
      path: "/cmslist",
      name: "CMS Management",
      icon: <BiBookContent />,
    },
    {
      path: "/networklist",
      name: "Network Management",
      icon: <FaNetworkWired />,
    },
    {
      path: "/categorylist",
      name: "Category Management",
      icon: <MdCategory />,
    },
    {
      path: "/subcategorylist",
      name: "SubCategory Management",
      icon: <MdCategory />,
    },
    {
      path: "/announcementlist",
      name: "Announcement Management",
      icon: <MdCategory />,
    },
    {
      path: "/sociallist",
      name: "SocialLink Management",
      icon: <TbSocial />,
    },
    {
      path: "/questionadd",
      name: "Question Management",
      icon: <FaQuestionCircle />,
    },
    {
      path: "/cointokenlist",
      name: "List Coin/Token",
      icon: <FaQuestionCircle />,
    },
     {
      path: "/exchangelist",
      name: "List Exchange",
      icon: <FaQuestionCircle />,
    },
    {
      path: "/ViewFormLists",
      name: "List Forms",
      icon: <FaQuestionCircle />,
    },
  ]);


  const location = useLocation();
  const widthResize = ResizeHook();


  return (
    <div className="sidebar">
      <div className="sidebar_head">
        {
          widthResize > 991 ?
            <Link to="/">
              <img src={Logo} alt="Edaface" className="img-fluid logo" />
            </Link> :
            <div className="d-flex align-items-center justify-content-between">
              <p className="mobilesidebar_head">Welcome Admin</p>
              <button type="button" className="btn closebtn" onClick={() => handleCloseHeader()}><IoClose /></button>
            </div>
        }
      </div>
      <div className="sidebar_body">
        <ul className="sidebar_ul">
          {
            sidebarlinks.map((sbl) => (
              <li className="sidebar_li" key={sbl.name}>
                <Link to={sbl.path} className={`sidebar_link ${location.pathname === sbl.path && "active"}`}>
                  {sbl.icon} {sbl.name}
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  )
}

export default Sidebar;